/**
 *
 * Tooltip
 *
 */
import React, { memo } from 'react';
import { Tooltip as AntdTooltip, TooltipProps as AntdTooltipProps } from 'antd';

interface TooltipProps {}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Tooltip(props: TooltipProps & AntdTooltipProps) {
  return <AntdTooltip {...props} />;
}

export default memo(Tooltip);
